module.exports = __webpack_public_path__ + "img/f_3.0c17661.png";